// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import {endpoints} from "./endpoints";

export const environment = {
  production: false,
  apiUrl: 'https://api.foundek.com/app',
  //¡¡apiUrl: 'http://localhost:8000/app',
  appVersion: '1.0.1',
  termsAndConditionsUrl: 'https://api.foundek.com/terms-and-conditions',
  privacyPolicyUrl: 'https://api.foundek.com/privacy-policy',
  cookiePolicyUrl: 'https://api.foundek.com/cookie-policy',
  refundPolicyUrl: 'https://api.foundek.com/refund-policy',
  legalNoticeUrl: 'https://api.foundek.com/legal-notice',
  googleMaps: {
    apiKey: 'AIzaSyCEpxHnDSAFKGZAHbNvVAEQaF-7Iiyce3c'
  },
  stripe_key: 'pk_test_51RSw7QPIF6MZitj3TKbhxQ3LBaXuuzaEkbH8xTieu3QKEZfsyijkm23yLXoqcrMpv8hqdODVC76u41CZBesaBZdI00ntw7CRpr',
  api_broadcast: 'https://api.foundek.com/app/broadcasting/auth',
  pusher_key: '722270108fb7d401c77b',
  pusher_cluster: 'eu',
  // Configuración de Firebase
  firebase: {
    apiKey: "AIzaSyBKhJZRi7NJvJE3c2xPEZYJAXu8W_VP61o",
    authDomain: "foundek-app.firebaseapp.com",
    projectId: "foundek-app",
    storageBucket: "foundek-app.firebasestorage.app",
    messagingSenderId: "380800586037",
    appId: "1:380800586037:web:6322e690029657bf37fc7c"
  },
  ...endpoints
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
